<template>
    <v-app id="inspire">
        <v-main>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <v-form @submit.prevent="doLogin">
                            <v-card class="elevation-12">
                                <v-toolbar dark color="primary">
                                    <v-toolbar-title
                                        >Jacob Store Manager</v-toolbar-title
                                    >
                                </v-toolbar>

                                <v-card-text>
                                    <v-alert
                                        border="left"
                                        color="red"
                                        type="error"
                                        v-if="errorString"
                                        v-html="errorString"
                                    ></v-alert>
                                    <v-form>
                                        <v-text-field
                                            prepend-icon="person"
                                            name="email"
                                            label="E-Mail"
                                            type="email"
                                            v-model="email"
                                        ></v-text-field>
                                        <v-text-field
                                            id="password"
                                            prepend-icon="lock"
                                            name="password"
                                            label="Password"
                                            type="password"
                                            v-model="password"
                                        ></v-text-field>
                                        <div class="text-right">
                                            <p>
                                                Password dimenticata?
                                                <router-link
                                                    :to="{
                                                        name: 'recupero-password',
                                                    }"
                                                >
                                                    Clicca qui</router-link
                                                >
                                            </p>
                                        </div>
                                    </v-form>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" type="submit"
                                        >Login</v-btn
                                    >
                                </v-card-actions>
                            </v-card>
                        </v-form>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import requests from "../requests";
import helpers from "../helpers";
import router from "../router";
export default {
    name: "Login",
    props: {
        source: String,
    },

    data: () => {
        return {
            email: "",
            password: "",
            errorString: false,
        };
    },

    methods: {
        doLogin() {
            this.errorString = "";
            requests.login(this.email, this.password).then((res) => {
                if (!_.isUndefined(res.response)) {
                    this.errorString = helpers.formatAjaxError(
                        res.response.data
                    );
                } else {
                    window.currentUser = res.data;
                    window.localStorage.setItem(
                        "user",
                        JSON.stringify(res.data)
                    );
                    router.push({ name: "product-list" });
                }
            });
        },
    },
};
</script>
